"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _InteractionManagerHelper_drawingToolsManager, _InteractionManagerHelper_eventEngine, _InteractionManagerHelper_geometryMathManager, _InteractionManagerHelper_geometryState, _InteractionManagerHelper_interactionManager, _InteractionManagerHelper_settings, _InteractionManagerHelper_draggedPoint, _InteractionManagerHelper_draggedPointPosition, _InteractionManagerHelper_dragging, _InteractionManagerHelper_hoveredPoint, _InteractionManagerHelper_justSelected, _InteractionManagerHelper_lastRay, _InteractionManagerHelper_midPointInserted, _InteractionManagerHelper_moving, _InteractionManagerHelper_propagatedBasePositions, _InteractionManagerHelper_selectedMovedPointPositions, _InteractionManagerHelper_selectedPointIndices, _InteractionManagerHelper_selectedPointPositions;
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionManagerHelper = void 0;
const viewer_1 = require("@shapediver/viewer");
const viewer_rendering_engine_intersection_restriction_engine_1 = require("@shapediver/viewer.rendering-engine.intersection-restriction-engine");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const gl_matrix_1 = require("gl-matrix");
const IDrawingToolsManager_1 = require("../../../../interfaces/IDrawingToolsManager");
class InteractionManagerHelper {
    constructor(drawingToolsManager, interactionManager) {
        _InteractionManagerHelper_drawingToolsManager.set(this, void 0);
        _InteractionManagerHelper_eventEngine.set(this, viewer_shared_services_1.EventEngine.instance);
        _InteractionManagerHelper_geometryMathManager.set(this, void 0);
        _InteractionManagerHelper_geometryState.set(this, void 0);
        _InteractionManagerHelper_interactionManager.set(this, void 0);
        _InteractionManagerHelper_settings.set(this, void 0);
        _InteractionManagerHelper_draggedPoint.set(this, void 0);
        _InteractionManagerHelper_draggedPointPosition.set(this, gl_matrix_1.vec3.create());
        _InteractionManagerHelper_dragging.set(this, false);
        _InteractionManagerHelper_hoveredPoint.set(this, void 0);
        _InteractionManagerHelper_justSelected.set(this, false);
        _InteractionManagerHelper_lastRay.set(this, void 0);
        _InteractionManagerHelper_midPointInserted.set(this, false);
        _InteractionManagerHelper_moving.set(this, false);
        _InteractionManagerHelper_propagatedBasePositions.set(this, new Map());
        _InteractionManagerHelper_selectedMovedPointPositions.set(this, []);
        _InteractionManagerHelper_selectedPointIndices.set(this, []);
        _InteractionManagerHelper_selectedPointPositions.set(this, []);
        __classPrivateFieldSet(this, _InteractionManagerHelper_drawingToolsManager, drawingToolsManager, "f");
        __classPrivateFieldSet(this, _InteractionManagerHelper_interactionManager, interactionManager, "f");
        __classPrivateFieldSet(this, _InteractionManagerHelper_geometryState, __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").geometryState, "f");
        __classPrivateFieldSet(this, _InteractionManagerHelper_geometryMathManager, __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").geometryMathManager, "f");
        __classPrivateFieldSet(this, _InteractionManagerHelper_settings, __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").settings, "f");
        (0, viewer_1.addListener)(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.GEOMETRY_CHANGED, (e) => {
            const event = e;
            if (event.drawingToolsId !== __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").uuid)
                return;
            this.removeAllSelectedPoints();
        });
    }
    get dragging() {
        return __classPrivateFieldGet(this, _InteractionManagerHelper_dragging, "f");
    }
    get hoveredPoint() {
        return __classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f");
    }
    set hoveredPoint(value) {
        __classPrivateFieldSet(this, _InteractionManagerHelper_hoveredPoint, value, "f");
    }
    get midPointInserted() {
        return __classPrivateFieldGet(this, _InteractionManagerHelper_midPointInserted, "f");
    }
    set midPointInserted(value) {
        __classPrivateFieldSet(this, _InteractionManagerHelper_midPointInserted, value, "f");
    }
    get moving() {
        return __classPrivateFieldGet(this, _InteractionManagerHelper_moving, "f");
    }
    set moving(value) {
        __classPrivateFieldSet(this, _InteractionManagerHelper_moving, value, "f");
    }
    get selectedPointIndices() {
        return __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f");
    }
    /**
     * A point was added so we have to move the selected indices one forward if they are after the insertion index
     *
     * @param insertionIndex
     */
    addPoint(insertionIndex) {
        var _a;
        // move index if it is the hovered index
        if (__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f") !== undefined &&
            __classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f") >= insertionIndex) {
            if (__classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").includes(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"))) {
                __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").updateMaterialIndex(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"), IDrawingToolsManager_1.MATERIAL_INDEX.SELECTED);
            }
            else if (__classPrivateFieldGet(this, _InteractionManagerHelper_interactionManager, "f").midPointInteractionHandler
                .midPointInsertionIndex === insertionIndex) {
                __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").updateMaterialIndex(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"), IDrawingToolsManager_1.MATERIAL_INDEX.INSERTION);
            }
            else {
                __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").updateMaterialIndex(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"), IDrawingToolsManager_1.MATERIAL_INDEX.DEFAULT);
            }
            __classPrivateFieldSet(this, _InteractionManagerHelper_hoveredPoint, (_a = __classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"), _a++, _a), "f");
            if (__classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").includes(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"))) {
                __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").updateMaterialIndex(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"), IDrawingToolsManager_1.MATERIAL_INDEX.SELECTED_HOVERED);
            }
            else if (__classPrivateFieldGet(this, _InteractionManagerHelper_interactionManager, "f").midPointInteractionHandler
                .midPointInsertionIndex === __classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f")) {
                __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").updateMaterialIndex(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"), IDrawingToolsManager_1.MATERIAL_INDEX.INSERTION_HOVERED);
            }
            else {
                __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").updateMaterialIndex(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"), IDrawingToolsManager_1.MATERIAL_INDEX.HOVERED);
            }
        }
        // move selected indices one forward if they are after the insertion index
        __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").forEach((element, i) => {
            __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f")[i] =
                element >= insertionIndex ? element + 1 : element;
        });
    }
    /**
     * Check if there is a point close to the ray and update the hovered point
     *
     * @param event
     * @param ray
     * @returns
     */
    checkHover(distances, ray) {
        if (!ray && !__classPrivateFieldGet(this, _InteractionManagerHelper_lastRay, "f"))
            return;
        if (!ray)
            ray = __classPrivateFieldGet(this, _InteractionManagerHelper_lastRay, "f");
        __classPrivateFieldSet(this, _InteractionManagerHelper_lastRay, ray, "f");
        // check if there is a point close to the ray
        if (distances) {
            // add the id if it is not already in the array
            // remove it if it is in the array
            const index = distances[0].index;
            if (__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f") !== undefined &&
                __classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f") === index)
                return;
            if (__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f") !== undefined) {
                if (this.isPointDisabled(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"))) {
                    __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").updateMaterialIndex(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"), IDrawingToolsManager_1.MATERIAL_INDEX.DISABLED);
                }
                else if (__classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").includes(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"))) {
                    __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").updateMaterialIndex(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"), IDrawingToolsManager_1.MATERIAL_INDEX.SELECTED);
                }
                else if (__classPrivateFieldGet(this, _InteractionManagerHelper_interactionManager, "f").midPointInteractionHandler
                    .midPointInsertionIndex === index) {
                    __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").updateMaterialIndex(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"), IDrawingToolsManager_1.MATERIAL_INDEX.INSERTION);
                }
                else if (__classPrivateFieldGet(this, _InteractionManagerHelper_interactionManager, "f").insertionInteractionHandler
                    .insertionActive === true &&
                    __classPrivateFieldGet(this, _InteractionManagerHelper_interactionManager, "f").insertionInteractionHandler
                        .alreadyInserted === true &&
                    __classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f") ===
                        __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").getPointCount() - 1) {
                    __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").updateMaterialIndex(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"), IDrawingToolsManager_1.MATERIAL_INDEX.INSERTION);
                }
                else {
                    __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").updateMaterialIndex(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"), IDrawingToolsManager_1.MATERIAL_INDEX.DEFAULT);
                }
            }
            if (this.isPointDisabled(index)) {
                __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").updateMaterialIndex(index, IDrawingToolsManager_1.MATERIAL_INDEX.DISABLED);
            }
            else if (__classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").includes(index)) {
                __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").updateMaterialIndex(index, IDrawingToolsManager_1.MATERIAL_INDEX.SELECTED_HOVERED);
            }
            else if (__classPrivateFieldGet(this, _InteractionManagerHelper_interactionManager, "f").midPointInteractionHandler
                .midPointInsertionIndex === index) {
                __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").updateMaterialIndex(index, IDrawingToolsManager_1.MATERIAL_INDEX.INSERTION_HOVERED);
            }
            else if (__classPrivateFieldGet(this, _InteractionManagerHelper_interactionManager, "f").insertionInteractionHandler
                .insertionActive === true &&
                __classPrivateFieldGet(this, _InteractionManagerHelper_interactionManager, "f").insertionInteractionHandler
                    .alreadyInserted === true &&
                index === __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").getPointCount() - 1) {
                __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").updateMaterialIndex(index, IDrawingToolsManager_1.MATERIAL_INDEX.INSERTION_HOVERED);
            }
            else {
                __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").updateMaterialIndex(index, IDrawingToolsManager_1.MATERIAL_INDEX.HOVERED);
            }
            __classPrivateFieldSet(this, _InteractionManagerHelper_hoveredPoint, index, "f");
        }
        else {
            // remove the hovered point if there is no point close to the ray
            if (__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f") !== undefined) {
                if (this.isPointDisabled(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"))) {
                    __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").updateMaterialIndex(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"), IDrawingToolsManager_1.MATERIAL_INDEX.DISABLED);
                }
                else if (__classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").includes(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"))) {
                    __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").updateMaterialIndex(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"), IDrawingToolsManager_1.MATERIAL_INDEX.SELECTED);
                }
                else if (__classPrivateFieldGet(this, _InteractionManagerHelper_interactionManager, "f").midPointInteractionHandler
                    .midPointInsertionIndex === __classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f")) {
                    __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").updateMaterialIndex(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"), IDrawingToolsManager_1.MATERIAL_INDEX.INSERTION);
                }
                else if (__classPrivateFieldGet(this, _InteractionManagerHelper_interactionManager, "f").insertionInteractionHandler
                    .insertionActive === true &&
                    __classPrivateFieldGet(this, _InteractionManagerHelper_interactionManager, "f").insertionInteractionHandler
                        .alreadyInserted === true &&
                    __classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f") ===
                        __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").getPointCount() - 1) {
                    __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").updateMaterialIndex(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"), IDrawingToolsManager_1.MATERIAL_INDEX.INSERTION_HOVERED);
                }
                else {
                    __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").updateMaterialIndex(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"), IDrawingToolsManager_1.MATERIAL_INDEX.DEFAULT);
                }
            }
            __classPrivateFieldSet(this, _InteractionManagerHelper_hoveredPoint, undefined, "f");
        }
    }
    close() {
        __classPrivateFieldSet(this, _InteractionManagerHelper_selectedPointIndices, [], "f");
        __classPrivateFieldSet(this, _InteractionManagerHelper_hoveredPoint, undefined, "f");
        __classPrivateFieldSet(this, _InteractionManagerHelper_draggedPoint, undefined, "f");
        __classPrivateFieldSet(this, _InteractionManagerHelper_dragging, false, "f");
        __classPrivateFieldSet(this, _InteractionManagerHelper_selectedPointPositions, [], "f");
        __classPrivateFieldSet(this, _InteractionManagerHelper_selectedMovedPointPositions, [], "f");
        __classPrivateFieldSet(this, _InteractionManagerHelper_draggedPointPosition, gl_matrix_1.vec3.create(), "f");
        __classPrivateFieldGet(this, _InteractionManagerHelper_propagatedBasePositions, "f").clear();
    }
    deselectPoint(index) {
        const selectedIndex = __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").indexOf(index);
        if (selectedIndex !== -1) {
            __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").splice(selectedIndex, 1);
            __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").updateMaterialIndex(index, __classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f") === index
                ? IDrawingToolsManager_1.MATERIAL_INDEX.HOVERED
                : IDrawingToolsManager_1.MATERIAL_INDEX.DEFAULT);
            __classPrivateFieldGet(this, _InteractionManagerHelper_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.DESELECTED, {
                viewportId: __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").viewport.id,
                drawingToolsId: __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").uuid,
                index,
            });
        }
    }
    moveSelectedPoints(ray) {
        if (__classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").length > 0 && __classPrivateFieldGet(this, _InteractionManagerHelper_dragging, "f")) {
            __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").restrictionManager.showRestrictionVisualization =
                true;
            const rayTraceResult = __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").restrictionManager.rayTrace(ray, {
                type: "drawing",
                index: __classPrivateFieldGet(this, _InteractionManagerHelper_draggedPoint, "f"),
                startPoint: gl_matrix_1.vec3.clone(__classPrivateFieldGet(this, _InteractionManagerHelper_draggedPointPosition, "f")),
                positionArray: __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").positionArray,
            });
            const intersectionPoint = rayTraceResult === null || rayTraceResult === void 0 ? void 0 : rayTraceResult.point;
            if (intersectionPoint) {
                const differenceToIntersected = gl_matrix_1.vec3.sub(gl_matrix_1.vec3.create(), intersectionPoint, __classPrivateFieldGet(this, _InteractionManagerHelper_draggedPointPosition, "f"));
                // Phase 1 – compute constrained proposed positions for every
                // directly-selected point, building an overrides map so that
                // each peer's constrained position is visible when checking the
                // next point's size constraint.
                // Seed with drag-start positions of propagated (indirect) points
                // so that constraint checks see stable original positions, not
                // stale values from positionArray that may have been
                // contaminated by temporary moves (e.g. flushRectPoints).
                const overrides = new Map(__classPrivateFieldGet(this, _InteractionManagerHelper_propagatedBasePositions, "f"));
                const constrainedPositions = [];
                for (let i = 0; i < __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").length; i++) {
                    const isLastPoint = __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").length === 1 &&
                        __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f")[0] ===
                            __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").getPointCount() - 1;
                    const canBeClosed = __classPrivateFieldGet(this, _InteractionManagerHelper_settings, "f").geometry.mode === "lines" &&
                        __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").getPointCount() > 3 &&
                        __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").checkNumberOfPoints(__classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").getPointCount() - 1);
                    const shouldBeClosed = __classPrivateFieldGet(this, _InteractionManagerHelper_settings, "f").geometry.close === true &&
                        __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").closeLoop === false &&
                        __classPrivateFieldGet(this, _InteractionManagerHelper_settings, "f").geometry.autoClose === false;
                    let rawProposed;
                    if (isLastPoint && canBeClosed && shouldBeClosed) {
                        const firstPoint = __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").getPosition(0);
                        if (__classPrivateFieldGet(this, _InteractionManagerHelper_geometryMathManager, "f").screenSpaceDistanceCheck(firstPoint, intersectionPoint, __classPrivateFieldGet(this, _InteractionManagerHelper_settings, "f").visualization.points.size_0 *
                            __classPrivateFieldGet(this, _InteractionManagerHelper_settings, "f").visualization
                                .distanceMultiplicationFactor).check === true) {
                            // snap to first point to close the geometry
                            rawProposed = gl_matrix_1.vec3.clone(firstPoint);
                        }
                        else {
                            rawProposed = gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), differenceToIntersected, __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointPositions, "f")[i]);
                        }
                    }
                    else {
                        rawProposed = gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), differenceToIntersected, __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointPositions, "f")[i]);
                    }
                    const constrained = __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").applyConstraints(rawProposed, __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f")[i], overrides, __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointPositions, "f")[i]);
                    constrainedPositions.push(constrained);
                    overrides.set(__classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f")[i], constrained);
                }
                // Effective delta for the dragged point after constraint clamping.
                const draggedSelIdx = __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").indexOf(__classPrivateFieldGet(this, _InteractionManagerHelper_draggedPoint, "f"));
                const effectiveDelta = draggedSelIdx >= 0
                    ? gl_matrix_1.vec3.sub(gl_matrix_1.vec3.create(), constrainedPositions[draggedSelIdx], __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointPositions, "f")[draggedSelIdx])
                    : differenceToIntersected;
                // Phase 2 – compute indirect (constraint-clamped) positions.
                const { indirectPositions, correctedDelta } = this.applyAdjacencyPropagation(effectiveDelta, overrides);
                // If indirect constraints required reducing the effective delta
                // per-axis, re-derive direct point positions so that the
                // rectangle invariant (shared coordinates) is maintained.
                if (correctedDelta) {
                    for (let i = 0; i < __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").length; i++) {
                        constrainedPositions[i] = gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointPositions, "f")[i], correctedDelta);
                        overrides.set(__classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f")[i], constrainedPositions[i]);
                    }
                }
                // Phase 3 – apply constrained positions to direct points.
                // Constraints are already applied in Phase 1, skip re-application
                // to avoid stale positionArray reads producing wrong results.
                for (let i = 0; i < __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").length; i++) {
                    __classPrivateFieldGet(this, _InteractionManagerHelper_selectedMovedPointPositions, "f")[i] =
                        constrainedPositions[i];
                    __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").movePoint(__classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f")[i], constrainedPositions[i], rayTraceResult, true, true);
                }
                // Phase 4 – apply pre-computed indirect positions.
                // Constraints are already applied in Phase 2, skip re-application
                // to avoid stale positionArray reads producing wrong results.
                for (const [targetIdx, pos] of indirectPositions) {
                    __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").movePoint(targetIdx, pos, __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").metadataArray[targetIdx], true, true);
                }
                __classPrivateFieldGet(this, _InteractionManagerHelper_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.DRAG_MOVE, {
                    viewportId: __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").viewport.id,
                    drawingToolsId: __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").uuid,
                    points: __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").getPointsData(),
                    index: __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").length === 1
                        ? __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f")[0]
                        : undefined,
                    indices: __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").length > 1
                        ? __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f")
                        : undefined,
                    metaData: __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").metadataArray,
                });
            }
            return intersectionPoint;
        }
    }
    onOut() {
        if (__classPrivateFieldGet(this, _InteractionManagerHelper_dragging, "f") === true) {
            // reset all selected points to their original position
            __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").forEach((element, i) => {
                __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").movePointTemporary(element, __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointPositions, "f")[i], __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").metadataArray[element]);
            });
            // reset the dragged point position
            __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").movePointTemporary(__classPrivateFieldGet(this, _InteractionManagerHelper_draggedPoint, "f"), __classPrivateFieldGet(this, _InteractionManagerHelper_draggedPointPosition, "f"), __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").metadataArray[__classPrivateFieldGet(this, _InteractionManagerHelper_draggedPoint, "f")]);
            // reset any propagated points to their pre-drag positions
            __classPrivateFieldGet(this, _InteractionManagerHelper_propagatedBasePositions, "f").forEach((basePos, idx) => {
                __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").movePointTemporary(idx, basePos, __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").metadataArray[idx]);
            });
        }
        // remove the hovered point and the selected points
        this.removeAllSelectedPoints();
    }
    onUp() {
        if (__classPrivateFieldGet(this, _InteractionManagerHelper_moving, "f") === true && __classPrivateFieldGet(this, _InteractionManagerHelper_dragging, "f") === true) {
            const selectedPointIndices = __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").slice();
            for (let i = 0; i < __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").length; i++)
                __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").makePointPersistent(__classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f")[i], false);
            /**
             * Check if the geometry should be closed
             */
            const isLastPoint = selectedPointIndices.length === 1 &&
                selectedPointIndices[0] ===
                    __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").getPointCount() - 1;
            const canBeClosed = __classPrivateFieldGet(this, _InteractionManagerHelper_settings, "f").geometry.mode === "lines" &&
                __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").getPointCount() > 3 &&
                __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").checkNumberOfPoints(__classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").getPointCount() - 1);
            const shouldBeClosed = __classPrivateFieldGet(this, _InteractionManagerHelper_settings, "f").geometry.close === true &&
                __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").closeLoop === false &&
                __classPrivateFieldGet(this, _InteractionManagerHelper_settings, "f").geometry.autoClose === false;
            if (isLastPoint && canBeClosed && shouldBeClosed) {
                // if restricted point is close to the first point, remove the current insertion point and draw a line to the first point
                const firstPoint = __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").getPosition(0);
                const lastPoint = __classPrivateFieldGet(this, _InteractionManagerHelper_selectedMovedPointPositions, "f")[0];
                if (lastPoint &&
                    __classPrivateFieldGet(this, _InteractionManagerHelper_geometryMathManager, "f").screenSpaceDistanceCheck(firstPoint, lastPoint, __classPrivateFieldGet(this, _InteractionManagerHelper_settings, "f").visualization.points.size_0 *
                        __classPrivateFieldGet(this, _InteractionManagerHelper_settings, "f").visualization
                            .distanceMultiplicationFactor).check === true) {
                    // close the geometry
                    __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").closeLoop = true;
                    __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").removePoint(selectedPointIndices[0]);
                }
            }
            this.removeAllSelectedPoints();
            __classPrivateFieldGet(this, _InteractionManagerHelper_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.GEOMETRY_CHANGED, {
                viewportId: __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").viewport.id,
                drawingToolsId: __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").uuid,
                points: __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").getPointsData(),
                metaData: __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").metadataArray,
                temporary: false,
                fromHistory: false,
            });
            __classPrivateFieldGet(this, _InteractionManagerHelper_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.DRAG_END, {
                viewportId: __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").viewport.id,
                drawingToolsId: __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").uuid,
                points: __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").getPointsData(),
                index: selectedPointIndices.length === 1
                    ? selectedPointIndices[0]
                    : undefined,
                indices: selectedPointIndices.length > 1
                    ? selectedPointIndices
                    : undefined,
                metaData: __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").metadataArray,
            });
        }
        else if (__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f") !== undefined &&
            __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").includes(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"))) {
            if (__classPrivateFieldGet(this, _InteractionManagerHelper_justSelected, "f") === __classPrivateFieldGet(this, _InteractionManagerHelper_moving, "f"))
                this.toggleSelection(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"));
            if (__classPrivateFieldGet(this, _InteractionManagerHelper_midPointInserted, "f")) {
                /**
                 * SPECIAL CASE:
                 * - A MIDPOINT WAS ADDED, BUT NOT DRAGGED
                 * - HAS TO BE ADDED TO THE HISTORY NOW
                 */
                __classPrivateFieldGet(this, _InteractionManagerHelper_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.GEOMETRY_CHANGED, {
                    viewportId: __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").viewport.id,
                    drawingToolsId: __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").uuid,
                    points: __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").getPointsData(),
                    metaData: __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").metadataArray,
                    temporary: false,
                });
            }
        }
    }
    /**
     * Remove all selected points
     */
    removeAllSelectedPoints() {
        while (__classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").length > 0)
            this.toggleSelection(__classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f")[0]);
    }
    /**
     * A point was removed so we have to move the selected indices one back if they are after the removal index
     *
     * @param removalIndex
     */
    removePoint(removalIndex) {
        var _a;
        // remove index if it is the hovered index
        if (__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f") === removalIndex) {
            __classPrivateFieldSet(this, _InteractionManagerHelper_hoveredPoint, undefined, "f");
        }
        if (__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f") !== undefined &&
            __classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f") > removalIndex) {
            __classPrivateFieldSet(this, _InteractionManagerHelper_hoveredPoint, (_a = __classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"), _a--, _a), "f");
        }
        // remove index from selected indices
        const indexInArray = __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").indexOf(removalIndex);
        if (indexInArray !== -1) {
            __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").splice(indexInArray, 1);
        }
        // move selected indices one back if they are after the removal index
        __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").forEach((element, i) => {
            __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f")[i] =
                element > removalIndex ? element - 1 : element;
        });
    }
    reset() {
        __classPrivateFieldSet(this, _InteractionManagerHelper_justSelected, false, "f");
        __classPrivateFieldSet(this, _InteractionManagerHelper_midPointInserted, false, "f");
        __classPrivateFieldSet(this, _InteractionManagerHelper_moving, false, "f");
        __classPrivateFieldSet(this, _InteractionManagerHelper_dragging, false, "f");
        __classPrivateFieldSet(this, _InteractionManagerHelper_selectedPointPositions, [], "f");
        __classPrivateFieldSet(this, _InteractionManagerHelper_selectedMovedPointPositions, [], "f");
        __classPrivateFieldGet(this, _InteractionManagerHelper_propagatedBasePositions, "f").clear();
    }
    selectPoint(distances) {
        if (distances) {
            // add the id if it is not already in the array
            // remove it if it is in the array
            if (this.isPointDisabled(distances[0].index))
                return;
            if (!__classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").includes(distances[0].index)) {
                this.toggleSelection(distances[0].index);
                __classPrivateFieldSet(this, _InteractionManagerHelper_justSelected, true, "f");
            }
        }
    }
    startDragging() {
        const selectedAndHovered = __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").length > 0 &&
            __classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f") !== undefined &&
            __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").includes(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"));
        // Fallback: when no points are selected but a point is hovered, drag it
        // directly. This supports translation without requiring selection.
        const hoverOnlyDrag = !selectedAndHovered &&
            __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").length === 0 &&
            __classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f") !== undefined;
        if (!selectedAndHovered && !hoverOnlyDrag)
            return false;
        // Disabled points cannot be dragged
        if (__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f") !== undefined &&
            this.isPointDisabled(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f")))
            return false;
        if (hoverOnlyDrag) {
            // Temporarily track the hovered point so moveSelectedPoints works.
            // It is cleaned up by removeAllSelectedPoints() in onUp().
            __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").push(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"));
        }
        // store selected point positions
        __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").forEach((element) => __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointPositions, "f").push(__classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").getPosition(element)));
        // copy values into selected moved point positions
        __classPrivateFieldSet(this, _InteractionManagerHelper_selectedMovedPointPositions, __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointPositions, "f").map((element) => gl_matrix_1.vec3.clone(element)), "f");
        __classPrivateFieldSet(this, _InteractionManagerHelper_draggedPointPosition, __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").getPosition(__classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f")), "f");
        __classPrivateFieldSet(this, _InteractionManagerHelper_draggedPoint, __classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f"), "f");
        __classPrivateFieldSet(this, _InteractionManagerHelper_dragging, true, "f");
        this.collectPropagatedBasePositions();
        __classPrivateFieldGet(this, _InteractionManagerHelper_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.DRAG_START, {
            viewportId: __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").viewport.id,
            drawingToolsId: __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").uuid,
        });
        return true;
    }
    /**
     * Traverse the adjacency graph from all currently selected points and store the
     * pre-drag world-space position of every reachable non-selected point so that
     * delta propagation can work from a stable baseline across multiple move frames.
     */
    collectPropagatedBasePositions() {
        const adjacency = __classPrivateFieldGet(this, _InteractionManagerHelper_settings, "f").geometry.weightedAdjacency;
        if (!adjacency)
            return;
        const queue = [...__classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f")];
        const expanded = new Set(__classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f"));
        while (queue.length > 0) {
            const sourceIdx = queue.shift();
            const adjList = adjacency[sourceIdx];
            if (!adjList)
                continue;
            for (const { to: targetIdx } of adjList) {
                if (__classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").includes(targetIdx))
                    continue;
                if (!__classPrivateFieldGet(this, _InteractionManagerHelper_propagatedBasePositions, "f").has(targetIdx)) {
                    __classPrivateFieldGet(this, _InteractionManagerHelper_propagatedBasePositions, "f").set(targetIdx, __classPrivateFieldGet(this, _InteractionManagerHelper_geometryState, "f").getPosition(targetIdx));
                }
                if (!expanded.has(targetIdx)) {
                    expanded.add(targetIdx);
                    queue.push(targetIdx);
                }
            }
        }
    }
    /**
     * Convert a world-space source delta into a weighted propagation delta.
     *
     * "world" (default): multiply XYZ components directly by weights.
     * "local": decompose the delta along the active plane restriction's U/V/N axes,
     *          apply per-axis weights, then recompose.  Falls back to "world" when no
     *          enabled plane restriction is present.
     */
    /**
     * Find the active plane restriction's local axes (U, V, N).
     * Returns undefined when no enabled plane restriction is present.
     */
    getActivePlaneAxes() {
        const planeRestriction = Object.values(__classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").restrictionManager.restrictions).find((r) => r.type === viewer_rendering_engine_intersection_restriction_engine_1.RESTRICTION_TYPE.PLANE && r.enabled);
        if (!planeRestriction)
            return undefined;
        return [
            planeRestriction.vectorU,
            planeRestriction.vectorV,
            planeRestriction.normal,
        ];
    }
    /**
     * Scale a world-space delta per local axis.
     * Decomposes into the local U/V/N basis, applies per-axis scale factors,
     * then recomposes to world space.
     */
    scaleInLocalAxes(delta, axisScales, localAxes) {
        const [u, v, n] = localAxes;
        const result = gl_matrix_1.vec3.create();
        gl_matrix_1.vec3.scaleAndAdd(result, result, u, gl_matrix_1.vec3.dot(delta, u) * axisScales[0]);
        gl_matrix_1.vec3.scaleAndAdd(result, result, v, gl_matrix_1.vec3.dot(delta, v) * axisScales[1]);
        gl_matrix_1.vec3.scaleAndAdd(result, result, n, gl_matrix_1.vec3.dot(delta, n) * axisScales[2]);
        return result;
    }
    computeWeightedDelta(sourceDelta, weights, space) {
        if (space === "local") {
            const localAxes = this.getActivePlaneAxes();
            if (localAxes) {
                const [u, v, n] = localAxes;
                const du = gl_matrix_1.vec3.dot(sourceDelta, u);
                const dv = gl_matrix_1.vec3.dot(sourceDelta, v);
                const dn = gl_matrix_1.vec3.dot(sourceDelta, n);
                const result = gl_matrix_1.vec3.create();
                gl_matrix_1.vec3.scaleAndAdd(result, result, u, du * weights[0]);
                gl_matrix_1.vec3.scaleAndAdd(result, result, v, dv * weights[1]);
                gl_matrix_1.vec3.scaleAndAdd(result, result, n, dn * weights[2]);
                return result;
            }
        }
        return gl_matrix_1.vec3.fromValues(sourceDelta[0] * weights[0], sourceDelta[1] * weights[1], sourceDelta[2] * weights[2]);
    }
    /**
     * BFS propagation of a drag delta through the weightedAdjacency graph.
     *
     * Runs the BFS exactly once, validates constraints for every indirect
     * point, and returns a ready-to-apply position map so the caller can
     * commit the moves without any redundant computation.
     *
     * @param differenceToIntersected  Effective drag delta (already
     *                                  constraint-clamped for the dragged point).
     * @param overrides                 Positions of directly-moved points, used
     *                                  as reference geometry when checking size
     *                                  constraints for indirect points.
     * @returns Indirect positions and, when indirect constraints required
     *          reducing the effective delta, a correctedDelta for the caller
     *          to re-derive direct point positions from.
     */
    applyAdjacencyPropagation(differenceToIntersected, overrides) {
        const adjacency = __classPrivateFieldGet(this, _InteractionManagerHelper_settings, "f").geometry.weightedAdjacency;
        if (!adjacency || __classPrivateFieldGet(this, _InteractionManagerHelper_propagatedBasePositions, "f").size === 0)
            return { indirectPositions: new Map() };
        // Seed BFS from all selected points.
        const queue = __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").map((idx) => [idx, differenceToIntersected]);
        const expanded = new Set(__classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f"));
        const accumulatedDeltas = new Map();
        const processSource = (sourceIdx, sourceDelta) => {
            const adjList = adjacency[sourceIdx];
            if (!adjList)
                return;
            for (const entry of adjList) {
                const { to: targetIdx, weights, space } = entry;
                if (__classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").includes(targetIdx))
                    continue;
                const weightedDelta = this.computeWeightedDelta(sourceDelta, weights, space);
                if (accumulatedDeltas.has(targetIdx)) {
                    gl_matrix_1.vec3.add(accumulatedDeltas.get(targetIdx), accumulatedDeltas.get(targetIdx), weightedDelta);
                }
                else {
                    accumulatedDeltas.set(targetIdx, gl_matrix_1.vec3.clone(weightedDelta));
                }
                // Queue target for chain propagation (using its received delta).
                if (!expanded.has(targetIdx)) {
                    expanded.add(targetIdx);
                    queue.push([targetIdx, weightedDelta]);
                }
            }
        };
        while (queue.length > 0) {
            const [sourceIdx, sourceDelta] = queue.shift();
            processSource(sourceIdx, sourceDelta);
        }
        // Detect whether any adjacency entry uses "local" space so the
        // correction path can operate along the plane restriction's U/V/N axes
        // instead of world X/Y/Z.  This ensures correct behavior even when the
        // geometry is rotated relative to the world frame.
        let localAxes;
        outer: for (const list of adjacency) {
            for (const entry of list) {
                if (entry.space === "local") {
                    localAxes = this.getActivePlaneAxes();
                    break outer;
                }
            }
        }
        // First pass: check constraints and compute per-axis scale factors.
        // When an indirect point is clamped on axis i, we determine how much
        // the source delta on that axis must be reduced so the indirect point
        // lands exactly at the constraint boundary. The most restrictive
        // (smallest) scale factor per axis wins.
        // When localAxes is set, "axis i" refers to the plane's U/V/N axes;
        // otherwise it refers to world X/Y/Z.
        const axisScales = [1, 1, 1];
        let needsCorrection = false;
        for (const [targetIdx, delta] of accumulatedDeltas) {
            const base = __classPrivateFieldGet(this, _InteractionManagerHelper_propagatedBasePositions, "f").get(targetIdx);
            if (!base)
                continue;
            const proposed = gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), base, delta);
            const constrained = __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").applyConstraints(proposed, targetIdx, overrides, base);
            if (localAxes) {
                // Decompose delta and correction along local U/V/N axes.
                const diff = gl_matrix_1.vec3.sub(gl_matrix_1.vec3.create(), constrained, base);
                for (let i = 0; i < 3; i++) {
                    const deltaLocal = gl_matrix_1.vec3.dot(delta, localAxes[i]);
                    const constrainedLocal = gl_matrix_1.vec3.dot(diff, localAxes[i]);
                    if (Math.abs(deltaLocal) > 1e-10 &&
                        Math.abs(constrainedLocal - deltaLocal) > 1e-10) {
                        const scale = Math.max(0, constrainedLocal / deltaLocal);
                        if (scale < axisScales[i]) {
                            axisScales[i] = scale;
                            needsCorrection = true;
                        }
                    }
                }
            }
            else {
                for (let i = 0; i < 3; i++) {
                    if (Math.abs(delta[i]) > 1e-10 &&
                        Math.abs(constrained[i] - proposed[i]) > 1e-10) {
                        const scale = Math.max(0, (constrained[i] - base[i]) / delta[i]);
                        if (scale < axisScales[i]) {
                            axisScales[i] = scale;
                            needsCorrection = true;
                        }
                    }
                }
            }
        }
        if (!needsCorrection) {
            // All proposed positions satisfy constraints.
            const indirectPositions = new Map();
            for (const [targetIdx, delta] of accumulatedDeltas) {
                const base = __classPrivateFieldGet(this, _InteractionManagerHelper_propagatedBasePositions, "f").get(targetIdx);
                if (!base)
                    continue;
                indirectPositions.set(targetIdx, gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), base, delta));
            }
            return { indirectPositions };
        }
        // Compute corrected effective delta (scaled per-axis).
        const correctedDelta = localAxes
            ? this.scaleInLocalAxes(differenceToIntersected, axisScales, localAxes)
            : gl_matrix_1.vec3.fromValues(differenceToIntersected[0] * axisScales[0], differenceToIntersected[1] * axisScales[1], differenceToIntersected[2] * axisScales[2]);
        // Recompute indirect positions using the scaled deltas.
        const indirectPositions = new Map();
        for (const [targetIdx, delta] of accumulatedDeltas) {
            const base = __classPrivateFieldGet(this, _InteractionManagerHelper_propagatedBasePositions, "f").get(targetIdx);
            if (!base)
                continue;
            const scaledDelta = localAxes
                ? this.scaleInLocalAxes(delta, axisScales, localAxes)
                : gl_matrix_1.vec3.fromValues(delta[0] * axisScales[0], delta[1] * axisScales[1], delta[2] * axisScales[2]);
            indirectPositions.set(targetIdx, gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), base, scaledDelta));
        }
        return { indirectPositions, correctedDelta };
    }
    /**
     * Select a point, deselect it if it is already selected
     *
     * @param index
     */
    toggleSelection(index) {
        // Disabled points cannot be selected
        if (this.isPointDisabled(index))
            return;
        // add the id if it is not already in the array
        // remove it if it is in the array
        const indexInArray = __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").indexOf(index);
        if (indexInArray === -1) {
            __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").push(index);
            __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").updateMaterialIndex(index, __classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f") === index
                ? IDrawingToolsManager_1.MATERIAL_INDEX.SELECTED_HOVERED
                : IDrawingToolsManager_1.MATERIAL_INDEX.SELECTED);
            __classPrivateFieldGet(this, _InteractionManagerHelper_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.SELECTED, {
                viewportId: __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").viewport.id,
                drawingToolsId: __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").uuid,
                index,
            });
        }
        else {
            __classPrivateFieldGet(this, _InteractionManagerHelper_selectedPointIndices, "f").splice(indexInArray, 1);
            __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").updateMaterialIndex(index, __classPrivateFieldGet(this, _InteractionManagerHelper_hoveredPoint, "f") === index
                ? IDrawingToolsManager_1.MATERIAL_INDEX.HOVERED
                : IDrawingToolsManager_1.MATERIAL_INDEX.DEFAULT);
            __classPrivateFieldGet(this, _InteractionManagerHelper_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.DESELECTED, {
                viewportId: __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").viewport.id,
                drawingToolsId: __classPrivateFieldGet(this, _InteractionManagerHelper_drawingToolsManager, "f").uuid,
                index,
            });
        }
    }
    isPointDisabled(index) {
        var _a, _b;
        return (_b = (_a = __classPrivateFieldGet(this, _InteractionManagerHelper_settings, "f").geometry.disabledPoints) === null || _a === void 0 ? void 0 : _a.includes(index)) !== null && _b !== void 0 ? _b : false;
    }
}
exports.InteractionManagerHelper = InteractionManagerHelper;
_InteractionManagerHelper_drawingToolsManager = new WeakMap(), _InteractionManagerHelper_eventEngine = new WeakMap(), _InteractionManagerHelper_geometryMathManager = new WeakMap(), _InteractionManagerHelper_geometryState = new WeakMap(), _InteractionManagerHelper_interactionManager = new WeakMap(), _InteractionManagerHelper_settings = new WeakMap(), _InteractionManagerHelper_draggedPoint = new WeakMap(), _InteractionManagerHelper_draggedPointPosition = new WeakMap(), _InteractionManagerHelper_dragging = new WeakMap(), _InteractionManagerHelper_hoveredPoint = new WeakMap(), _InteractionManagerHelper_justSelected = new WeakMap(), _InteractionManagerHelper_lastRay = new WeakMap(), _InteractionManagerHelper_midPointInserted = new WeakMap(), _InteractionManagerHelper_moving = new WeakMap(), _InteractionManagerHelper_propagatedBasePositions = new WeakMap(), _InteractionManagerHelper_selectedMovedPointPositions = new WeakMap(), _InteractionManagerHelper_selectedPointIndices = new WeakMap(), _InteractionManagerHelper_selectedPointPositions = new WeakMap();
//# sourceMappingURL=InteractionManagerHelper.js.map